// @ts-nocheck

import React, { useEffect, useState } from "react";
import { notification } from "antd";
import "../Login.css";
import Logo from "../../../theme/images/logo_oseo_valais_retina.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { http } from "../../../engine/api/http";
import CustomForm from "../../../shared/components/CustomForm";
import back from "../../../theme/images/back.jpeg";
import { getLogoByCustomer } from "../../../engine/customerConfig";
import { useTranslation } from "react-i18next";

export const PasswordReset = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(() => {
    if (token === null) {
      navigate("/", { replace: true });
    }
  }, []);

  const [loading, setLoading] = useState(false);

  const passwordRules = [
    {
      required: true,
      message: t("publicRegister.passwordRequired"),
    },
    {
      min: 8,
      message: t("publicRegister.passwordMinLength"),
    },
    {
      pattern: /[a-z]/,
      message: t("publicRegister.passwordLowercase"),
    },
    {
      pattern: /[A-Z]/,
      message: t("publicRegister.passwordUppercase"),
    },
    {
      pattern: /\d/,
      message: t("publicRegister.passwordNumber"),
    },
    {
      pattern: /[!@#$%^&*(),.?":{}|<>_\-\/\\[\]`~]/,
      message: t("publicRegister.passwordSpecialCharacter"),
    },
  ];

  const inputsPassword = [
    {
      parentLabel: "Changer le Mot de passe",
      children: [
        {
          label: "Nouveau mot de passe",
          name: "password1",
          value: "",
          type: "password",
          col: 11,
          offset: 0,
          required: true,
          rules: passwordRules,
        },
        {
          label: "Recopier le nouveau mot de passe",
          name: "password2",
          value: "",
          required: true,
          type: "password",
          col: 12,
          offset: 1,
          rules: [
            {
              required: true,
              message: t("publicRegister.confirmPasswordRequired"),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password1") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(t("publicRegister.passwordsDoNotMatch")),
                );
              },
            }),
          ],
        },
      ],
    },
    {
      children: [
        {
          label: "Changer le mot de passe",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "left",
        },
      ],
    },
  ];

  const onSubmitFormPassword = async data => {
    try {
      setLoading(true);

      let send = await http.post("/auth/reset", {
        password: data.password1,
        token,
      });

      notification.success({
        message: `Vous pouvez vous connecter`,
        description: "Votre mot de passe a été changé.",
      });
      navigate("/", { replace: true });
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  return (
    <div className={"login-back"} style={{ backgroundImage: `url(${back})` }}>
      <Helmet>
        <title>OSEO Valais - Nouveau mot de passe</title>
      </Helmet>
      <div className={"login-container"} style={{ width: "700px" }}>
        <div className={"login-box"}>
          <img src={getLogoByCustomer()} className={"login-logo"} />
          <CustomForm
            dataSource={inputsPassword}
            labelCol={24}
            wrapperCol={24}
            handleSubmit={onSubmitFormPassword}
          />
        </div>
      </div>
    </div>
  );
};
